import { Car, Bike, Truck, FileCheck, Wrench, Recycle, Phone, MessageCircle } from "lucide-react";
import { SITE, IMAGES } from "../lib/site";
import { Reveal, MaskedLines } from "../components/Reveal";
import { useSeo } from "../hooks/useSeo";

const items = [
  { icon: Car, title: "Rottamazione Auto", specs: ["Ogni marca e modello", "Con o senza documenti", "Anche incidentate o allagate"], text: "Demoliamo autovetture di qualsiasi tipo. Verifichiamo i documenti, gestiamo la radiazione e ti consegniamo il certificato di demolizione." },
  { icon: Truck, title: "Furgoni & Veicoli Commerciali", specs: ["Van e autocarri leggeri", "Trasporto con carroattrezzi", "Ritiro anche presso magazzini"], text: "Ritiro e demolizione di furgoni e mezzi commerciali fuori uso o non più a norma, con trasporto dedicato." },
  { icon: Bike, title: "Moto, Scooter & Ciclomotori", specs: ["Due e tre ruote", "Radiazione al PRA", "Ritiro rapido"], text: "Rottamazione di moto e scooter di ogni cilindrata con pratiche complete di radiazione." },
  { icon: FileCheck, title: "Pratiche & Certificato PRA", specs: ["Certificato di demolizione", "Radiazione dal PRA", "Nessuna coda agli uffici"], text: "Ci occupiamo di tutta la burocrazia. Ricevi il certificato ufficiale a norma di legge senza muoverti da casa." },
  { icon: Wrench, title: "Ritiro Veicoli Fermi", specs: ["Auto abbandonate", "Mezzi senza revisione", "Recupero da garage e box"], text: "Recuperiamo veicoli fermi da anni, in box, cortili o strada, liberando il tuo spazio." },
  { icon: Recycle, title: "Smaltimento Ecologico", specs: ["Centri autorizzati", "Recupero materiali", "Rispetto ambientale"], text: "Ogni veicolo viene avviato a demolizione in impianti autorizzati, nel pieno rispetto delle normative ambientali." },
];

export default function Servizi() {
  useSeo({
    title: "Servizi di Rottamazione a Roma | Auto, Moto, Furgoni, PRA",
    description:
      "Rottamazione auto, moto, scooter e furgoni a Roma. Ritiro veicoli fermi, certificato di demolizione, radiazione al PRA e smaltimento ecologico.",
    path: "/servizi",
  });
  return (
    <div>
      <section className="relative overflow-hidden border-b border-[#232323] pt-40 pb-20">
        <img src={IMAGES.scrapPile} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" style={{ filter: "grayscale(1)" }} />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] to-transparent" />
        <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-8">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#8a8a8a]">/ Servizi</p>
          <h1 className="mt-4 font-num uppercase leading-[0.85] tracking-tight text-[13vw] md:text-[9vw]">
            <MaskedLines lines={["Cosa", "Rottamiamo"]} />
          </h1>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 md:px-8 py-20 md:py-28">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {items.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={(i % 3) * 0.06}>
                <div className="group flex h-full flex-col border border-[#232323] bg-[#0f0f0f] p-8 transition-colors duration-200 hover:bg-[#1a1a1a]">
                  <Icon size={30} strokeWidth={1.5} className="text-[#ff3300]" />
                  <h2 className="mt-8 font-display text-3xl tracking-wide">{s.title}</h2>
                  <p className="mt-3 font-mono text-sm leading-relaxed text-[#8a8a8a]">{s.text}</p>
                  <ul className="mt-6 space-y-2 border-t border-[#232323] pt-6">
                    {s.specs.map((sp) => (
                      <li key={sp} className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.1em] text-[#8a8a8a]">
                        <span className="h-1 w-3 bg-[#ff3300]" /> {sp}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="border-t border-[#232323] bg-[#0f0f0f]">
        <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-8 px-5 md:px-8 py-16 md:flex-row md:items-center">
          <h2 className="font-display text-4xl md:text-6xl tracking-wide">Serve rottamare un veicolo?</h2>
          <div className="flex flex-wrap gap-3">
            <a href={`tel:${SITE.phoneTel}`} data-testid="servizi-call" className="flex items-center gap-3 border border-[#ff3300] bg-[#ff3300] px-6 py-4 font-mono text-xs uppercase tracking-[0.16em] text-black transition-colors duration-150 hover:bg-transparent hover:text-[#ff3300]">
              <Phone size={16} /> Chiama ora
            </a>
            <a href={SITE.whatsappMsg} target="_blank" rel="noreferrer" data-testid="servizi-whatsapp" className="flex items-center gap-3 border border-[#232323] px-6 py-4 font-mono text-xs uppercase tracking-[0.16em] transition-colors duration-150 hover:border-[#25d366] hover:text-[#25d366]">
              <MessageCircle size={16} /> WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
